import { jsx as _jsx } from "react/jsx-runtime";
import { Suspense } from 'react';
import { RouterProvider, createBrowserRouter } from 'react-router-dom';
import Content from 'src/pages/content';
import { ContentList } from 'src/pages/contentList';
import Mentorship from 'src/pages/mentorship';
import Module from 'src/pages/module';
import { Root } from 'src/pages/root';
import { Loader } from 'src/shared/components/loader';
import { Routes } from 'src/shared/constants/routes';
function createRouter(basename) {
    const router = createBrowserRouter([
        {
            path: Routes.Root,
            element: _jsx(Root, {}),
            errorElement: null,
            children: [
                { path: Routes.ContentImport, element: null },
                {
                    path: Routes.ListModules,
                    element: _jsx(ContentList, {}),
                    children: [
                        { path: Routes.ManageModule, element: _jsx(Module, {}) },
                        { path: Routes.ManageContent, element: _jsx(Content, {}) },
                        { path: Routes.ManageMentorshipModule, element: _jsx(Mentorship, {}) }
                    ]
                },
                // Avoid 404 if host changes path
                { path: '/*', element: null }
            ]
        }
    ], { basename });
    return router;
}
export function Router({ basename }) {
    const router = createRouter(basename);
    return (_jsx(Suspense, { fallback: _jsx(Loader, { full: "screen" }), children: _jsx(RouterProvider, { router: router }) }));
}
